import {Component, Optional} from "@angular/core";
import {AccountSearchModel} from "../account-search.model";
import {AccountEntityModel} from "../account-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {FUIStackedPageContextService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-account-search-page",
    templateUrl: "./account-search-page.component.html",
    providers: [provideSearchModel(AccountSearchModel), provideEntityModel(AccountEntityModel)]
})
export class AccountSearchPageComponent extends AbstractSearchPage {

    disableAddNew: boolean;

    constructor(@Optional() stackedPageContextService: FUIStackedPageContextService) {
        super();
        if (stackedPageContextService && stackedPageContextService.params.searchParams && stackedPageContextService.params.searchParams.disableAddNew) {
            this.disableAddNew = true;
        }
    }
}
